import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
    '& .MuiTableCell-head': {
      backgroundColor: theme.palette.background.tableHeader,
    },
    '& .MuiInputLabel-root': {
      color: theme.palette.primary.main,
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.main,
    },
  },
  action: {
    marginBottom: theme.spacing(1),
    '& + &': {
      marginLeft: theme.spacing(1),
    },
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.white,
  },
  actionIcon: {
    marginRight: theme.spacing(1),
  },
  queryField: {
    width: 500,
  },
  bulkOperations: {
    position: 'relative',
  },
  bulkActions: {
    paddingLeft: 4,
    paddingRight: 4,
    marginLeft: 25,
    marginTop: 10,
    position: 'relative',
    width: '120px',
    backgroundColor: theme.palette.background.main,
  },
  bulkAction: {
    marginLeft: theme.spacing(2),
  },
  deleteButtonTableCell: {
    display: 'flex',
  },
  avatar: {
    height: 42,
    width: 42,
    marginRight: theme.spacing(1),
  },
  header: {
    backgroundColor: theme.palette.background.dark,
  },
  listModal: {
    height: '400px',
    width: '100%',
    overflow: 'auto',
  },
  updateProduct: {
    backgroundColor: '#C5C200',
    '&:hover': {
      backgroundColor: '#C5C200',
    },
  },
  addProduct: {
    backgroundColor: '#3BB701',
    '&:hover': {
      backgroundColor: '#3BB701',
    },
  },
}));

export default useStyles;
